<div class="page-content container2">
  <case-header-new-view
    [view]="'Alert'"
    (recharge)="update()"
  ></case-header-new-view>
  <cases-content-new-view></cases-content-new-view>
</div>
